import findBySlug from "./find-by-slug";

const findVideo = (
  route,
  { parentDay, parentSeasonContentForSchoolLevel, parentSchoolLevel },
) => {
  // If we have a routed day, then we
  // are looking for a day video.
  if (parentDay) {
    return findBySlug(parentDay.videos, route.params.videoSlug);
  }

  // If we have a routed seasonContentForSchoolLevel,
  // then we are looking for a season video.
  if (parentSeasonContentForSchoolLevel) {
    return findBySlug(
      parentSeasonContentForSchoolLevel.videos,
      route.params.videoSlug,
    );
  }

  // Otherwise, we must be looking for a school level archive song.
  return findBySlug(parentSchoolLevel.archivedVideos, route.params.videoSlug);
};

export default function resolveRoutedVideo(route, parents, { getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  // If no song slug is provided, fall back
  // to the (archive or season) video list.
  if (!route.params?.videoSlug) {
    return null;
  }

  // Find the song by the route's video slug.
  return findVideo(route, parents);
}
